<template>
  <div>
    <mensajeSistema></mensajeSistema>
    <v-row>
      <v-col class="d-flex justify-center align-center">
        <ag-grid-vue
          class="ag-theme-balham"
          :style="{ width: '90%', height: '40vh' }"
          :rowData="rowData"
          :columnDefs="columnDefs"
          :domLayout="'autoHeight'"
          @cell-clicked="onCellClicked"
          @grid-ready="onGridReady"
          :localeText="localeTextSpanish"
        >
        </ag-grid-vue>
      </v-col>
    </v-row>

    <v-row>
    <v-col>
      <v-card-text class="ml-16">
        Total de horas semanales disponibles: {{ horasSemanalesLocal }}
      </v-card-text>
    </v-col>
  </v-row>

  
    <ComunDialogComp v-model="mostrarModal" persistent max-width="600px" :title="title" @close-modal="closeModal">
  <template v-slot:body>
    <v-form ref="form">
      <v-row justify="center" class="pa-0 ma-0">
        <v-col cols="6" class="d-flex align-center justify-start pa-0 ma-0">
          <v-card-text class="font-weight-bold pa-0 ma-0">ÁREA: {{ desc_area }}</v-card-text>
        </v-col>

        <v-col cols="12" class="d-flex align-center justify-start pa-0 ma-0">
          <v-card-text class="font-weight-bold pa-0 ma-0 mt-2">CURSO: {{ desc_curso }}</v-card-text>
        </v-col>

        <!-- Campo de Cantidad de horas académicas -->
        <v-col cols="8" class="d-flex align-center justify-start pa-0 ma-0">
          <v-card-text class="font-weight-bold mr-2 pa-0 ma-0">Cantidad de horas académicas:</v-card-text>
          <v-text-field
            v-model="cantidad"
            @input="validateForm"
            @blur="validateHoraSemanal"
            solo
            dense
            style="max-width: 100px; margin: 0"
            class="ma-0 pa-0 mt-5"
            :rules="cantidadRules"
            required
          ></v-text-field>
        </v-col>

        <!-- Campo de Temporalidad/semanal -->
        <v-col cols="8" class="d-flex align-center justify-start pa-0 ma-0">
          <v-card-text class="font-weight-bold mr-2 pa-0 ma-0">Temporalidad/semanal:</v-card-text>
          <v-text-field
            v-model="count"
            @input="validateForm"
            solo
            dense
            style="max-width: 100px; margin: 0"
            class="ma-0 pa-0 mt-5"
            :rules="countRules"
            required
          ></v-text-field>
        </v-col>

        <!-- Campos de Duración dinámicos -->
        <v-col v-if="formValid" cols="12" class="d-flex align-center justify-start pa-0 ma-0">
          <v-card-text class="font-weight-bold mr-2 pa-0 ma-0" >Duración en horas académicas de cada sesión:</v-card-text>
        </v-col>

        <v-col v-if="formValid" cols="12" class="d-flex align-center justify-start pa-0 ma-0">
          <v-row no-gutters>
            <v-col
              v-for="(duration, index) in durations"
              :key="index"
              cols="auto"
              class="d-flex flex-column align-center justify-start pr-1 pa-0 ma-0"
            >
              <v-text-field
                class="font-weight-bold ma-2 pa-0"
                :value="duration"
                v-model="durations[index]"
                solo
                dense
                style="max-width: 40px; margin: 0"
                :rules="durationRules(index)"
                @input="validateAndRecalculateDurations(index)"
              ></v-text-field>
              <div class="error-placeholder">
                <div v-if="durationMessages[index]" class="error-message">
                  {{ durationMessages[index] }}
                </div>
              </div>
            </v-col>
            <v-row dense>
              <v-col cols="12" class="d-flex align-center justify-end gap-10px pa-0 ma-0">
                <TableButtonCompVue normalButton @click="saveToDatabase" iconBut="fas fa-check" text-button="Guardar" />
                <TableButtonCompVue normalButton @click="closeModal" classColor="red" text-button="Cancelar" />
              </v-col>
                 </v-row>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </template>
</ComunDialogComp>

  </div>
</template>
<script>
import TableButtonCompVue from "../../../../components/ComponentsEst/TableButtonComp";
import { mapMutations } from "vuex";
import axios from '../../../../helpers/axios';
import ComunDialogComp from '../../../../../src/components/ComponentsEst/ComunDialogComp.vue';
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "Cursos",
  components: {
    AgGridVue,
    ComunDialogComp,
    TableButtonCompVue,
  },
  props: {
    id_nivel: {
      type: [String, Number],
      required: false,
    },
    cursosActualizados: {
      type: Array,
      default: () => []
    },
    horasSemanales: {
    type: Number,
    required: true
  },
  },
  data() {
    return {
      rowData: [
        { registro: true },
        { registro: false },
      ],
      columnDefs: [
        { headerName: "Areas", field: "desc_area", width: 220 },
        { headerName: "Cursos", field: "desc_curso", width: 220 },
        { headerName: "Cantidad de horas", field: "cantidad", width: 220 },
        { headerName: "Temporalidad", field: "temporalidad", width: 220 },
        { headerName: "Estado", field: "registro", width: 220 },
        { headerName: 'Editar', cellRenderer: this.iconCellRenderer }
      ],
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_colegio: sessionStorage.id_colegio,
      mostrarModal: false,
      localeTextSpanish: {
        noRowsToShow: "No hay datos para mostrar",
      },
      title: "Editar curso",
      datosCursos: [],
      desc_curso: "",
      desc_area: "",
      cantidad: '',
      count: '',
      durations: [],
      formValid: false,
      cantidadMessages: [],
      countMessages: [],
      durationMessages: [],
      allMessages: [],
      cantidadRules: [
        v => !!v || 'La cantidad es requerida',
        v => (v && v > 0) || 'Debe ser un número positivo',
        v => /^\d+$/.test(v) || 'Debe ser un número válido'
      ],
      countRules: [
        v => !!v || 'La cantidad es requerida',
        v => (v && v > 0) || 'Debe ser un número positivo',
        v => /^\d+$/.test(v) || 'Debe ser un número válido',
        v => (v <= parseInt(this.cantidad)) || `No puede ser mayor que la cantidad`
      ],
      horasSemanalesLocal: 0,
    };
  },
  watch: {
    cantidad(newVal) {
      if (newVal) {
        this.validateCantidad();
        if (this.count > newVal) {
          this.count = newVal;
        }
        this.validateCount(); 
        this.validateForm(); 
      }
    },
    count() {
      this.updateDurationFields();
    },
    cursosActualizados: {
      handler: 'getCurso',
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.getCurso();
  },
  methods: {

    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    durationRules() {
      return [
        v => !!v || '',
        v => (v && v >= 0) || 'Debe ser un número positivo',
        v => (v <= parseInt(this.cantidad)) || `No puede ser mayor que la cantidad`,
        v => /^\d+$/.test(v) || 'Debe ser un número válido'
      ];
    },
    validateCantidad() {
      this.cantidadMessages = [];
      for (let rule of this.cantidadRules) {
        const errorMessage = rule(this.cantidad);
        if (errorMessage !== true) {
          this.cantidadMessages.push(errorMessage);
          break; 
        }
      }
      return this.cantidadMessages.length === 0;
    },
    validateCount() {
      this.countMessages = [];
      for (let rule of this.countRules) {
        const errorMessage = rule(this.count);
        if (errorMessage !== true) {
          this.countMessages.push(errorMessage);
          break; 
        }
      }
      return this.countMessages.length === 0;
    },
    validateDurations() {
      this.durationMessages = [];
      for (let i = 0; i < this.durations.length; i++) {
        const duration = this.durations[i];
        for (let rule of this.durationRules(i)) {
          const errorMessage = rule(duration);
          if (errorMessage !== true) {
            this.durationMessages[i] = errorMessage;
            break; 
          } else {
            this.durationMessages[i] = null;
          }
        }
      }
      return this.durationMessages.every(msg => msg === null);
    },
    validateForm() {
      const isCantidadValid = this.validateCantidad();
      const isCountValid = this.validateCount();
      const isDurationValid = this.validateDurations();
      this.formValid = isCantidadValid && isCountValid && isDurationValid;
      this.allMessages = [...this.cantidadMessages, ...this.countMessages, ...this.durationMessages.filter(msg => msg)];
      if (this.formValid) {
        this.updateDurationFields();
      } else {
        this.durations = []; 
      }
      return this.formValid;
    },
    validateAndRecalculateDurations(index) {
      const duration = this.durations[index];
      if (duration <= this.cantidad && duration >= 0) {
        this.recalculateDurations(index, duration);
      }
      this.allMessages = [...this.cantidadMessages, ...this.countMessages, ...this.durationMessages.filter(msg => msg)];
    },
    recalculateDurations(index, value) {
      const totalHours = parseInt(this.cantidad) || 0;
      let remainingHours = totalHours - value;

      let newDurations = [...this.durations];
      newDurations[index] = value;

      for (let i = 0; i < newDurations.length; i++) {
        if (i !== index) {
          newDurations[i] = Math.min(remainingHours, newDurations[i]);
          remainingHours -= newDurations[i];
        }
      }

      if (remainingHours > 0) {
        for (let i = 0; i < newDurations.length && remainingHours > 0; i++) {
          if (i !== index) {
            newDurations[i] += remainingHours;
            remainingHours = 0;
          }
        }
      }

      this.durations = newDurations;
    },
    updateDurationFields() {
      const totalHours = parseInt(this.cantidad) || 0;
      const count = Math.max(parseInt(this.count) || 0, 1);
      const baseDuration = Math.floor(totalHours / count);
      const remainder = totalHours % count;

      this.durations = Array(count).fill(baseDuration).map((duration, index) => {
        return duration + (index < remainder ? 1 : 0);
      });

      // Si por alguna razón durations está vacío, inicialízalo a un array con al menos un valor.
      if (!this.durations || this.durations.length === 0) {
        this.durations = [0];
      }
    },

    validateHoraSemanal() {
    const cantidadIngresada = parseFloat(this.cantidad);

    // Validación para evitar NaN o valores no válidos
    if (isNaN(cantidadIngresada)) {
      return;
    }

    // Verificar que la cantidad ingresada no sea mayor que las horas disponibles
    if (cantidadIngresada > this.horasSemanalesLocal) {
      this.setEnviarMens({
          tipo: "E",
          mensaje: `La cantidad ingresada (${cantidadIngresada}) supera las horas disponibles (${this.horasSemanalesLocal}).`,
          tiempo: null,
        });
      return;
    }

    // Resta la cantidad ingresada a las horas disponibles
    this.horasSemanalesLocal -= cantidadIngresada;

    // Asegurarse de que no sea negativo
    if (this.horasSemanalesLocal < 0) {
      this.horasSemanalesLocal = 0;
    }

    },
     
    async getCurso() {
  try {
  
    // Inicializa una variable para calcular las horas ya registradas
    let horasRegistradas = 0;

    // Mapea los cursos para obtener los datos y calcular las horas registradas
    this.rowData = this.cursosActualizados.map(item => {
      let cantidad;

      // Verificar si el valor es un número válido antes de parsearlo
      if (item.cantidad_hora_semanales != null && !isNaN(item.cantidad_hora_semanales)) {
        cantidad = parseFloat(item.cantidad_hora_semanales);
      } else if (item.plan_de_estudio != null && !isNaN(item.plan_de_estudio)) {
        cantidad = parseFloat(item.plan_de_estudio);
      } else {
        cantidad = 0; // Si no hay valor válido, se establece en 0
      }

      // Sumar las horas registradas si la cantidad es un número válido
      if (!isNaN(cantidad)) {
        horasRegistradas += cantidad;
      } else {
        console.error("Cantidad no válida para el curso:", item.desc_curso, cantidad);
      }

      return {
        desc_area: item.desc_area,
        desc_curso: item.desc_curso,
        cantidad: cantidad,
        temporalidad: item.temporalidad_semanal,
        registro: item.registro,
        durations: item.durations || [0]
      };
    });


    // Calcular horas disponibles después de restar las horas ya registradas
    this.horasSemanalesLocal = this.horasSemanales - horasRegistradas;

    // Asegúrate de que no sea negativo
    if (this.horasSemanalesLocal < 0) {
      this.horasSemanalesLocal = 0;
    }

    // Actualizar la tabla con los nuevos datos
    if (this.gridApi) {
      this.gridApi.setRowData(this.rowData);
    }

  } catch (error) {
    console.log(error);
  }
},

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    iconCellRenderer(params) {
     
      const isTrue = params.data.registro;
      const iconElement = document.createElement('i');
      iconElement.className = 'fa fa-solid fa-pen';
      if (isTrue) {
        iconElement.classList.add('icon-blue');
      }
      return iconElement;
    },
    closeModal() {
      this.mostrarModal = false;
    },
    cleanModal() {
      this.count = "0";
      this.temporalidad_semanal = "0";
      this.durations = [0];
    },
    onCellClicked(event) {
     
      if (event.event.target.classList.contains("fa-pen")) {
        this.mostrarModal = true;
        this.desc_curso = event.data.desc_curso;
        this.desc_area = event.data.desc_area;
        this.cantidad = event.data.cantidad;
        this.count = event.data.temporalidad;
        this.durations = event.data.durations;
      }
    },
    async saveToDatabase() {
      const filteredCursos = this.cursosActualizados.filter(curso =>
        curso.desc_area.trim() === this.desc_area.trim() &&
        curso.desc_curso.trim() === this.desc_curso.trim()
      ).map(curso => ({
        ...curso,
        cantidad_hora_semanales: this.cantidad,
        temporalidad_semanal: this.count,
        durations: this.durations,
        id_ano_lectivo: this.id_ano_lectivo,
        id_colegio: this.id_colegio,
      }));
  
      // Preparar los parámetros a enviar
      let params = filteredCursos[0];
   
      try {
        await axios.post(`/horario/horarioCurso/`, { params });

        // emito emit al componente padre para actualizar datos
        this.$emit('datosGuardados');
        this.mostrarModal = false;
        this.cleanModal();
      } catch (error) {
       // this.setEnviarMens({ tipo: "E", mensaje: `Error: ${error.message}`, tiempo: null });
      }
    },
  }
};
</script>
<style scoped>
.error-placeholder {
  height: 1.5rem; 
}
.error-message {
  color: red;
  font-size: 0.75rem;
}
.error-messages {
  color: red;
  font-size: 0.75rem;
  background-color: white;
  padding: 10px;
  border-top: 1px solid #ccc;
}
.icon-blue {
  color: blue; /* Cambia el color del icono a azul */
}
</style>
